import React, { useState, useRef, useEffect } from 'react';
import '../../css/CustomDropdown.css';

const CustomDropdown = ({ options, value, onChange, name }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [highlighted, setHighlighted] = useState(0);
  const dropdownRef = useRef(null);

  const handleSelect = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  // Keyboard navigation
  const handleKeyDown = (e) => {
    if (!isOpen) {
      if (e.key === 'Enter' || e.key === ' ') setIsOpen(true);
      return;
    }
    if (e.key === 'ArrowDown') {
      setHighlighted((prev) => (prev + 1) % options.length);
    } else if (e.key === 'ArrowUp') {
      setHighlighted((prev) => (prev - 1 + options.length) % options.length);
    } else if (e.key === 'Enter') {
      handleSelect(options[highlighted].value);
    } else if (e.key === 'Escape') {
      setIsOpen(false);
    }
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen) {
      const idx = options.findIndex(opt => opt.value === value);
      setHighlighted(idx >= 0 ? idx : 0);
    }
  }, [isOpen, value, options]);

  const selectedOption = options.find(option => option.value === value) || options[0];

  return (
    <div
      className="custom-dropdown"
      ref={dropdownRef}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      aria-haspopup="listbox"
      aria-expanded={isOpen}
    >
      <div
        className="dropdown-selected"
        onClick={() => setIsOpen((open) => !open)}
        tabIndex={-1}
      >
        {selectedOption.label}
        <span className="dropdown-arrow">▼</span>
      </div>
      {isOpen && (
        <div className="dropdown-options" role="listbox">
          {options.map((option, idx) => (
            <div
              key={option.value}
              className={`dropdown-option${idx === highlighted ? ' highlighted' : ''}${option.value === value ? ' selected' : ''}`}
              onClick={() => handleSelect(option.value)}
              onMouseEnter={() => setHighlighted(idx)}
              role="option"
              aria-selected={option.value === value}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;